import { getBrandName } from '../brand-name';

type PaymentMethod = {
  img: string;
  paymentId: string;
  altImg: string;
};

export type PaymentMethodsData = PaymentMethod[];

export function getPaymentMethods(): PaymentMethodsData | null {
  const brandName = getBrandName();

  switch (brandName) {
    case 'tennisi':
    case 'chesnok':
      return null;
    default:
      assertExhaustiveness(brandName);
  }
}
